export default {
  labels: {
    free_items: 'Gratis varer',
    bogo: 'Køb en, få en gratis',
    order_again: 'Bestil igen',
  },
};
